import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            name: "home",
            props: true,
            component: () =>
                import ("./../src/components/LandingPage.vue"),
        },
        {
            path: "/contactUs",
            name: "ContactUs",
            props: true,
            component: () =>
                import ("./../src/components/ContactUs/contactUs"),
        },
        {
            path: "/ourPartners",
            name: "ourPartners",
            props: true,
            component: () =>
                import ("./../src/components/OurPartners.vue"),
        },
        {
            path: "/ourStory",
            name: "ourStory",
            props: true,
            component: () =>
                import ("./../src/components/OurStory.vue"),
        },
        {
            path: "/ourServices",
            name: "ourServices",
            props: true,
            component: () =>
                import ("./../src/components/OurFields.vue"),
        },
        {
            path: "/clients",
            name: "clients",
            props: true,
            component: () =>
                import ("./../src/components/ClientsPage.vue"),
        },
        {
            path: "/aiPage",
            name: "aiPage",
            props: true,
            component: () =>
                import ("./../src/components/AiPage.vue"),
        },
        {
            path: "/ourWorksHome",
            name: "ourWorksHome",
            props: true,
            component: () =>
                import ("./../src/components/OurWorks.vue"),
        },
        {
            path: "/blogs",
            name: "blogs",
            props: true,
            component: () =>
                import ("./../src/components/BlogsPage.vue"),
        },
        {
            path: "/startwithus",
            name: "startwithus",
            props: true,
            component: () =>
                import ("./../src/components/Forms/ProjectForm.vue"),
        },
        {
            path: "/ourWorks",
            name: "ourWorks",
            props: true,
            component: () =>
                import ("./../src/components/OurProducts.vue"),
        },
        {
            path: "/portfolio",
            name: "portfolio",
            props: true,
            component: () =>
                import ("./../src/components/PortFolio.vue"),
        },
        {
            path: "/app/privacy-policy",
            name: "App-privacypolicy",
            props: true,
            component: () =>
                import ("./../src/components/Apps/arenaPrivacyPolicy.vue"),
        },
        {
            path: "/ourTeam",
            name: "ourTeam",
            props: true,
            component: () =>
                import ("./components/SkillsPage.vue"),
        },
        {
            path: "/mobilAppDevelopment",
            name: "mobilAppDevelopment",
            props: true,
            component: () =>
                import ("./components/Services/MobileApp.vue"),
        },
        {
            path: "/webDevelopment",
            name: "webDevelopment",
            props: true,
            component: () =>
                import ("./components/Services/WebsitePage.vue"),
        },
        {
            path: "/uiuxDesign",
            name: "uiuxDesign",
            props: true,
            component: () =>
                import ("./components/Services/UiUxPage.vue"),
        },
        {
            path: "/cloudServices",
            name: "cloudServices",
            props: true,
            component: () =>
                import ("./components/Services/CloudServices.vue"),
        },
        {
            path: "/graphicDesign",
            name: "graphicDesign",
            props: true,
            component: () =>
                import ("./components/Services/GraphicsDesigns.vue"),
        },
        {
            path: "/SeoServices",
            name: "SeoServices",
            props: true,
            component: () =>
                import ("./components/Services/SeoAndDigitalMaketings.vue"),
        },
        {
            path: "/fieldStudy",
            name: "fieldStudy",
            props: true,
            component: () =>
                import ("./components/Services/FieldStudyAndDocumentations.vue"),
        },
        {
            path: "/artificialIntelligence",
            name: "artificialIntelligence",
            props: true,
            component: () =>
                import ("./components/Services/AiPage.vue"),
        },
        {
            path: "/caseStudy",
            name: "caseStudy",
            props: true,
            component: () =>
                import ("./components/CaseStudyPage.vue"),
        },
        {
            path: "/aboutUs",
            name: "aboutUs",
            props: true,
            component: () =>
                import ("./components/AboutUs.vue"),
        },
        {
            path: "/careers",
            name: "careers",
            props: true,
            component: () =>
                import ("./components/CareersPage.vue"),
        },
        {
            path: "/testimonials",
            name: "testimonials",
            props: true,
            component: () =>
                import ("./components/TestimonialsPage.vue"),
        },
        {
            path: "/privacy-policy",
            name: "PrivacyPolicy",
            props: true,
            component: () =>
                import ("./components/PrivacyPolicy.vue"),
        },
        {
            path: "/terms-and-conditions",
            name: "TermsAndConditions",
            props: true,
            component: () =>
                import ("./components/TermsOfUse.vue"),
        },
        {
            path: "/cookie-policy",
            name: "CookiePolicy",
            props: true,
            component: () =>
                import ("./components/CookiePolicy.vue"),
        },
        {
             path: '*',
        name: 'NotFound',
        component: () =>
                import ("./../src/components/NotFound.vue"),
        }
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },

});

export default router;